import { CrudAction, CrudAllAction } from '@mri-platform/resource-authz';
import { RouteInfo } from '@mri-platform/shared/core';
import { EntityName } from './entity-name';
import { SecuredResources } from './secured-resources';

export const AppRoutes = {
  ClientSelection: RouteInfo.path('client-selection'), // path must match AuthConfig.clientSelectionRoute (default: 'client-selection')
  Error: RouteInfo.path('error'),
  Home: RouteInfo.path('home').withEntityAuthz([EntityName.ReportInfo]),
  About: RouteInfo.path('about'),
  CommandCenter: RouteInfo.path('command-center').withFeatureName('commandCenter'),
  AiUsage: RouteInfo.path('ai-usage').withFeatureName('commandCenter'),
  DataSources: RouteInfo.path('data-sources').withFeatureName('dataSources'),
  PortfolioExplorer: RouteInfo.path('portfolio-explorer').withFeatureName('portfolioExplorer'),
  CreateModuleView: RouteInfo.path('create-module-view').withFeatureName('moduleViews'),
  ModuleView: RouteInfo.path('module-view').withFeatureName('moduleViews'),
  InsightEvals: RouteInfo.path('insight-evals').withFeatureName('insightEvals'),
  Dashboards: RouteInfo.path('dashboards').withEntityAuthz([EntityName.ReportInfo]).children({
    Detail: RouteInfo.detailPage()
  }),
  CreateDashboard: RouteInfo.path('create').withEntityAuthz([EntityName.ReportInfo], CrudAction.Create),
  AccessManagement: RouteInfo.path('access-management')
    .withEntityAuthz([EntityName.ReportAccess, EntityName.DatasetAccess], CrudAllAction.Read)
    .children({
      Groups: RouteInfo.path('groups')
        .withEntityAuthz([EntityName.Organisation, EntityName.Group])
        .children({
          GroupDetail: RouteInfo.detailPage('group'),
          OrganisationDetail: RouteInfo.detailPage('organisation')
        }),
      Users: RouteInfo.path('users')
        .withEntityAuthz([EntityName.User], CrudAllAction.Read)
        .children({
          UserDetail: RouteInfo.detailPage('user')
        })
    }),
  UserSettings: RouteInfo.path('user-settings').withEntityAuthz([EntityName.User]).children({
    Detail: RouteInfo.detailPage()
  }),
  AddUser: RouteInfo.path('Add-user').withEntityAuthz([EntityName.User], CrudAction.Create),
  Unauthorized: RouteInfo.path('unauthorized'),
  SwitchClient: RouteInfo.path('switch-client').withEntityAuthz([EntityName.Organisation]),
  Reconciliation: RouteInfo.path('reconciliation')
    .withFeatureName('reconciliation')
    .withEntityAuthz([EntityName.PbiReport]),
  ClientOnboardConfig: RouteInfo.path('onboard-config')
    .withEntityAuthz([EntityName.Organisation, EntityName.OrganisationWorkspace])
    .children({
      // todo: enhance route-info.ts to support the comment out code below
      // for now we're NOT guarding the ConfirmDelete route with authz permissions. that's not great but NOT a security
      // issue right now as the page doesn't actually perform any save to the api.
      ConfirmDelete: RouteInfo.path('confirm-delete'),
      // ConfirmDelete: RouteInfo.path('confirm-delete').withAuthz(OrganisationPrincipal.authorization[CrudAction.Delete])
      RecoverOrganisation: RouteInfo.path('organisation-recovery').withEntityAuthz(
        [EntityName.Organisation],
        'RecoverDelete'
      ),
      Status: RouteInfo.path('status').withAuthz({
        resource: [
          SecuredResources.Progress,
          SecuredResources.ProgressStage,
          SecuredResources.ActivityHistory,
          EntityName.OrganisationWorkspaceDeployment
        ],
        action: CrudAction.Read
      })
    })
};
